import React, { useRef, useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';

export const SignaturePad = ({ onChange }) => {
  const canvasRef = useRef(null);
  const [drawing, setDrawing] = useState(false);
  const [hasSig, setHasSig] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.strokeStyle = '#111827';
    ctx.lineWidth = 2;
    ctx.lineCap = 'round';
  }, []);

  const pos = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const t = e.touches ? e.touches[0] : e;
    return { x: t.clientX - rect.left, y: t.clientY - rect.top };
  };
  const start = (e) => { e.preventDefault(); setDrawing(true); const { x, y } = pos(e); const ctx = canvasRef.current.getContext('2d'); ctx.beginPath(); ctx.moveTo(x, y); };
  const move = (e) => { if (!drawing) return; e.preventDefault(); const { x, y } = pos(e); const ctx = canvasRef.current.getContext('2d'); ctx.lineTo(x, y); ctx.stroke(); setHasSig(true); };
  const end = () => { setDrawing(false); if (hasSig) onChange && onChange(canvasRef.current.toDataURL('image/png')); };
  const clear = () => { const c = canvasRef.current; c.getContext('2d').clearRect(0, 0, c.width, c.height); setHasSig(false); onChange && onChange(null); };

  return (
    <div>
      <canvas
        ref={canvasRef} width={320} height={140}
        className="w-full rounded-lg border border-border bg-white touch-none"
        onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
        onTouchStart={start} onTouchMove={move} onTouchEnd={end}
        data-testid="signature-pad"
      />
      <div className="flex justify-between items-center mt-2">
        <span className="text-xs text-muted-foreground">{hasSig ? 'Signature captured' : 'Sign above'}</span>
        <Button type="button" variant="ghost" size="sm" onClick={clear} data-testid="signature-clear-button">Clear</Button>
      </div>
    </div>
  );
};
